// Canonical sport identifiers used as `sport_code` on core.organization.
// Kept short and snake-case so they're stable across UI translations
// (the `i18nKey` is what users see; the `code` is what gets stored).
//
// Source order is not load-bearing — the picker sorts alphabetically by
// translated label (with "other" pinned last) at render time.

export interface Sport {
  code: string;
  i18nKey: string; // resolves under namespace 'common', e.g. 'sport.soccer'
}

export const sports: readonly Sport[] = [
  { code: 'football',       i18nKey: 'sport.football' },
  { code: 'ice-hockey',     i18nKey: 'sport.iceHockey' },
  { code: 'floorball',      i18nKey: 'sport.floorball' },
  { code: 'handball',       i18nKey: 'sport.handball' },
  { code: 'basketball',     i18nKey: 'sport.basketball' },
  { code: 'volleyball',     i18nKey: 'sport.volleyball' },
  { code: 'tennis',         i18nKey: 'sport.tennis' },
  { code: 'badminton',      i18nKey: 'sport.badminton' },
  { code: 'table-tennis',   i18nKey: 'sport.tableTennis' },
  { code: 'gymnastics',     i18nKey: 'sport.gymnastics' },
  { code: 'athletics',      i18nKey: 'sport.athletics' },
  { code: 'swimming',       i18nKey: 'sport.swimming' },
  { code: 'cycling',        i18nKey: 'sport.cycling' },
  { code: 'skiing',         i18nKey: 'sport.skiing' },
  { code: 'cross-country',  i18nKey: 'sport.crossCountry' },
  { code: 'biathlon',       i18nKey: 'sport.biathlon' },
  { code: 'figure-skating', i18nKey: 'sport.figureSkating' },
  { code: 'speed-skating',  i18nKey: 'sport.speedSkating' },
  { code: 'curling',        i18nKey: 'sport.curling' },
  { code: 'bandy',          i18nKey: 'sport.bandy' },
  { code: 'orienteering',   i18nKey: 'sport.orienteering' },
  { code: 'rugby',          i18nKey: 'sport.rugby' },
  { code: 'american-football', i18nKey: 'sport.americanFootball' },
  { code: 'baseball',       i18nKey: 'sport.baseball' },
  { code: 'softball',       i18nKey: 'sport.softball' },
  { code: 'cricket',        i18nKey: 'sport.cricket' },
  { code: 'golf',           i18nKey: 'sport.golf' },
  { code: 'martial-arts',   i18nKey: 'sport.martialArts' },
  { code: 'judo',           i18nKey: 'sport.judo' },
  { code: 'karate',         i18nKey: 'sport.karate' },
  { code: 'taekwondo',      i18nKey: 'sport.taekwondo' },
  { code: 'boxing',         i18nKey: 'sport.boxing' },
  { code: 'wrestling',      i18nKey: 'sport.wrestling' },
  { code: 'fencing',        i18nKey: 'sport.fencing' },
  { code: 'climbing',       i18nKey: 'sport.climbing' },
  { code: 'sailing',        i18nKey: 'sport.sailing' },
  { code: 'rowing',         i18nKey: 'sport.rowing' },
  { code: 'canoeing',       i18nKey: 'sport.canoeing' },
  { code: 'horse-riding',   i18nKey: 'sport.horseRiding' },
  { code: 'equestrian',     i18nKey: 'sport.equestrian' },
  { code: 'archery',        i18nKey: 'sport.archery' },
  { code: 'shooting',       i18nKey: 'sport.shooting' },
  { code: 'dance',          i18nKey: 'sport.dance' },
  { code: 'cheerleading',   i18nKey: 'sport.cheerleading' },
  { code: 'esports',        i18nKey: 'sport.esports' },
  { code: 'chess',          i18nKey: 'sport.chess' },
  { code: 'bowling',        i18nKey: 'sport.bowling' },
  { code: 'darts',          i18nKey: 'sport.darts' },
  { code: 'multi-sport',    i18nKey: 'sport.multiSport' },
  { code: 'other',          i18nKey: 'sport.other' },
];
